import { render, staticRenderFns } from "./3_CouvreFeu.vue?vue&type=template&id=efc1d5f8&scoped=true&"
import script from "./3_CouvreFeu.vue?vue&type=script&lang=js&"
export * from "./3_CouvreFeu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc1d5f8",
  null
  
)

export default component.exports